
// 对json和xml进行格式化
import vkbeautify from 'vkbeautify'
// jsonlint格式化json的js
import jsonlint from './jsonlint'

export function string_to_json_wrap(v) {
    try {
        if (is_json(v)) {
            return unicode_to_china(JSON.stringify(string_to_json(v), null, '\t'))
        } else {
            return v
        }
    } catch (e) {
        console.log(e);
    }
    return v
}

export function json_wrap_to_string(v) {
    try {
        if (is_json(v)) {
            return unicode_to_china(JSON.stringify(string_to_json(v)))

        } else {
            return v
        }

    } catch (e) {
        console.log(e);
    }
    return v
}


export function string_to_xml_wrap(v) {
    try {
        return vkbeautify.xml(v);
    } catch (e) {
        return v
    }
}

export function xml_wrap_to_string(v) {
    try {
        return vkbeautify.xmlmin(v);
    } catch (e) {
        return v
    }
}

export function is_json(str) {
    if (typeof str == 'string') {
        try {
            let obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            return false;
        }
    }
}

export function check_string_type(v) {
    try {
        if (v.startsWith("<!DOCTYPE html")) {
            return 'HTML'
        } else if (v.startsWith("<")) {
            return 'XML'
        } else if (is_json(v)) {
            return 'JSON'
        } else {
            return 'TEXT'
        }
    } catch (e) {
        return 'TEXT'
    }
}

export function wrap_to_string(v, t) {
    let type = t || check_string_type(v)
    switch (type) {
        case 'JSON': {
            return json_wrap_to_string(v)
        }
        case 'XML': {
            return xml_wrap_to_string(v)
        }
        case 'HTML': {
            return xml_wrap_to_string(v)
        }
    }
    return v
}

export function string_to_wrap(v, t) {
    let type = t || check_string_type(v)
    switch (type) {
        case 'JSON': {
            return string_to_json_wrap(v)
        }
        case 'XML': {
            return string_to_xml_wrap(v)
        }
        case 'HTML': {
            return string_to_xml_wrap(v)
        }
    }
    return v
}

export function string_to_json(v) {
    try {
        if (is_json(v)) {
            return jsonlint.parse(v)
        } else {
            return v
        }
    } catch (e) {
        return v
    }
}

export function unicode_to_china(input) {
    try {
        return input.replace(/\\\\u([0-9a-fA-F]{2,4})/g, function (string, matched) {
            return String.fromCharCode(parseInt(matched, 16))
        })
    } catch (e) {
        console.log(e);
    }
    return input
}


// 格式方法
// 公共方法
export function transitionJsonToString (jsonObj, callback) {
    // 转换后的jsonObj受体对象
    var _jsonObj = null;
    // 判断传入的jsonObj对象是不是字符串，如果是字符串需要先转换为对象，再转换为字符串，这样做是为了保证转换后的字符串为双引号
    if (Object.prototype.toString.call(jsonObj) !== "[object String]") {
        try {
            _jsonObj = JSON.stringify(jsonObj);
        } catch (error) {
            // 转换失败错误信息
            console.error('您传递的json数据格式有误，请核对...');
            console.error(error);
            callback(error);
        }
    } else {
        try {
            // eslint-disable-next-line no-useless-escape
            jsonObj = jsonObj.replace(/(\')/g, '\"');
            _jsonObj = JSON.stringify(JSON.parse(jsonObj));
        } catch (error) {
            // 转换失败错误信息
            console.error('您传递的json数据格式有误，请核对...');
            console.error(error);
            callback(error);
        }
    }
    return _jsonObj;
}
// callback为数据格式化错误的时候处理函数
export function formatJson (jsonObj, callback) {
    // 正则表达式匹配规则变量
    // 转换后的字符串变量
    var formatted = '';
    // 换行缩进位数
    var pad = 0;
    // 一个tab对应空格位数
    var PADDING = '    ';
    // json对象转换为字符串变量
    var jsonString = transitionJsonToString(jsonObj, callback);
    if (!jsonString) {
        return jsonString;
    }
    // 存储需要特殊处理的字符串段
    var _index = [];
    // 存储需要特殊处理的“再数组中的开始位置变量索引
    var _indexStart = null;
    // 存储需要特殊处理的“再数组中的结束位置变量索引
    var _indexEnd = null;
    // 将jsonString字符串内容通过\r\n符分割成数组
    var jsonArray = [];
    // 正则匹配到{,}符号则在两边添加回车换行
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/([\{\}])/g, '\r\n$1\r\n');
    // 正则匹配到[,]符号则在两边添加回车换行
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/([\[\]])/g, '\r\n$1\r\n');
    // 正则匹配到,符号则在两边添加回车换行
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/(\,)/g, '$1\r\n');
    // 正则匹配到要超过一行的换行需要改为一行
    jsonString = jsonString.replace(/(\r\n\r\n)/g, '\r\n');
    // 正则匹配到单独处于一行的,符号时需要去掉换行，将,置于同行
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/\r\n\,/g, ',');
    // 特殊处理双引号中的内容
    jsonArray = jsonString.split('\r\n');
    jsonArray.forEach(function (node, index) {
        // 获取当前字符串段中"的数量
        // eslint-disable-next-line no-useless-escape
        var num = node.match(/\"/g) ? node.match(/\"/g).length : 0;
        // 判断num是否为奇数来确定是否需要特殊处理
        if (num % 2 && !_indexStart) {
            _indexStart = index
        }
        if (num % 2 && _indexStart && _indexStart != index) {
            _indexEnd = index
        }
        // 将需要特殊处理的字符串段的其实位置和结束位置信息存入，并对应重置开始时和结束变量
        if (_indexStart && _indexEnd) {
            _index.push({
                start: _indexStart,
                end: _indexEnd
            })
            _indexStart = null
            _indexEnd = null
        }
    })
    // 开始处理双引号中的内容，将多余的"去除
    _index.reverse().forEach(function (item) {
        var newArray = jsonArray.slice(item.start, item.end + 1)
        jsonArray.splice(item.start, item.end + 1 - item.start, newArray.join(''))
    })
    // 奖处理后的数组通过\r\n连接符重组为字符串
    jsonString = jsonArray.join('\r\n');
    // 将匹配到:后为回车换行加大括号替换为冒号加大括号
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/\:\r\n\{/g, ':{');
    // 将匹配到:后为回车换行加中括号替换为冒号加中括号
    // eslint-disable-next-line no-useless-escape
    jsonString = jsonString.replace(/\:\r\n\[/g, ':[');
    // 将上述转换后的字符串再次以\r\n分割成数组
    jsonArray = jsonString.split('\r\n');
    // 将转换完成的字符串根据PADDING值来组合成最终的形态
    jsonArray.forEach(function (item) {
        console.log(item)
        var i = 0;
        // 表示缩进的位数，以tab作为计数单位
        var indent = 0;
        // 表示缩进的位数，以空格作为计数单位
        var padding = '';
        if (item.match(/\{$/) || item.match(/\[$/)) {
            // 匹配到以{和[结尾的时候indent加1
            indent += 1
        } else if (item.match(/\}$/) || item.match(/\]$/) || item.match(/\},$/) || item.match(/\],$/)) {
            // 匹配到以}和]结尾的时候indent减1
            if (pad !== 0) {
                pad -= 1
            }
        } else {
            indent = 0
        }
        for (i = 0; i < pad; i++) {
            padding += PADDING
        }
        formatted += padding + item + '\r\n'
        pad += indent
    })
    // 返回的数据需要去除两边的空格
    return formatted.trim();
}
